// extracted by mini-css-extract-plugin
var _1 = "Modal_closeButtonContainer__dOTID";
var _2 = "Modal_modalContent__O1Aa3";
var _3 = "Modal_openBody__Lp9zg";
var _4 = "'../shared.module.css'";
var _5 = "576px";
export { _1 as "closeButtonContainer", _2 as "modalContent", _3 as "openBody", _4 as "shared", _5 as "sm" }
